import React from "react";
import TimelineTable from "../TimelineTable";
import BudgetAllocation from "../BudgetAllocation/BudgetAllocation";

import LexicalEditor from "../../common/LexicalEditor";
import { EDITOR_LIMITS } from "../../../Constants";
const Step2 = ({ formik, containerClass }) => {
  return (
    <div
      className={`w-full flex flex-col ${containerClass} transition-all duration-300`}
    >
      <LexicalEditor
        onChange={(value) => {
          formik.setFieldValue("beneficiaries", value);
        }}
        id={"beneficiaries"}
        value={formik.values.beneficiaries}
        title={"Beneficiaries"}
        placeholder={
          "Beneficiaries are those who are likely to be interested in or to benefit from the proposed research, and describe how they will publicly access to the results."
        }
        containerClass="w-full mt-16"
        formik={formik}
        onBlur={formik.handleBlur}
        inputClass="h-52"
        limit={EDITOR_LIMITS.beneficiaries}
      />
      <LexicalEditor
        onChange={(value) => {
          formik.setFieldValue("equipment", value);
        }}
        id={"equipment"}
        value={formik.values.equipment}
        title={"Tools, Equipment and Materials"}
        placeholder={
          "Write about needed equipment and materials to accomplish your project"
        }
        containerClass="w-full mt-16"
        formik={formik}
        onBlur={formik.handleBlur}
        inputClass="h-52"
        limit={EDITOR_LIMITS.equipment}
      />

      <TimelineTable formik={formik} />
      <BudgetAllocation formik={formik} />
    </div>
  );
};

export default Step2;
